module.exports = __webpack_public_path__ + "static/img/qybj_02.f0cec55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_02.jpg
// module id = 3Xdc
// module chunks = 0